import { Box } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { IPaymentMethodReports } from "src/types/business-intelligence";
import sarIcon from "src/assets/svg-icons/sar.svg";

const colors = ["#CC9C33", "#A155B9", "#16AA75", "#84A59D", "#0075FF"];

const PaymentMethodChart = ({
  data,
}: {
  data: IPaymentMethodReports | undefined;
}) => {
  const series: number[] = [];
  if (data) {
    if (
      data.card.count > 0 ||
      data.cash.count > 0 ||
      data.online.count > 0 ||
      data.zaps.count ||
      data.thriwe.count
    ) {
      series.push(data?.cash.count);
      series.push(data?.card.count);
      series.push(data?.online.count);
      series.push(data?.zaps.count);
      series.push(data?.thriwe.count);
    }
  }

  const paymentMethods = [
    data?.cash,
    data?.card,
    data?.online,
    data?.zaps,
    data?.thriwe,
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      redrawOnParentResize: true,
      width: 380,
      type: "pie",
      foreColor: "#f0f0f0",
    },
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    colors: colors,
    labels: ["Cash", "Card", "Online", "Zaps", "Thriwe"],
    stroke: {
      show: false,
    },
    legend: {
      formatter: (seriesName, opts) => {
        const method = paymentMethods[opts.seriesIndex];

        return `${seriesName}: ${method?.count ?? 0} Tickets | <img src="${sarIcon}" style="width:11px;height:11px;vertical-align:middle;" /> ${(
          method?.amount ?? 0
        ).toLocaleString()}`;
      },
    },
    tooltip: {
      y: {
        formatter: (_, { seriesIndex }) => {
          const method = paymentMethods[seriesIndex];

          return `${method?.count ?? 0} Tickets | <img src="${sarIcon}" style="width:11px;height:11px;vertical-align:middle;" /> ${(method?.amount ?? 0).toLocaleString()}`;
        },
      },
    },
  };

  return (
    <Box px={{ xs: 1, lg: 4 }} pb={1.25}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="pie"
          width={"100%"}
          height={300}
        />
      </div>
    </Box>
  );
};
export default PaymentMethodChart;
